<template>
    <div class="h-100 pb-5" v-if="questionnaire && questionnaire.questions">
        <div id="q-header" class="sticky-top main-content-bg row pb-lg-4 align-middle pr-3 hide">
            <h3 class="mb-4 col-12 col-lg-10 pr-0"><i class="float-left mr-2" :class="questionnaire.is_anonymous ? 'fas fa-user-secret ' : ''"></i> {{ questionnaire.name }}</h3>
            <div class="save-answer-btn p-3 d-block d-lg-none">
                <button class="btn btn-primary col-12 col-lg-2" @click="postResponse()">Save Answers</button>
            </div>
            <button class="btn btn-primary col-12 col-lg-2 d-none d-lg-inline-block" @click="postResponse()">Save Answers</button>
            <div class="alert alert-dark w-100 mt-3 ml-3"><i class="fa fa-exclamation-circle mr-2" aria-hidden="true"></i> Please complete the survey questions below. You must click Save answers for your submission to be received.</div>
        </div>

        <div v-if="questionnaire && questionnaire.questions" style="transition-delay: 0s" class="scroll-panel pb-lg-5 pt-lg-0 mb-4">

            <transition-group name="slide-up">
                <div class="pb-lg-5" key="questions" v-if="completed && completed.length !== questionnaire.questions.length">
                    <section style="transition-delay: 0.4s" v-for="question in questionnaire.questions" v-bind:key="'q_'+question.id" :id="'q_'+question.id" class="question p-3 p-lg-5 text-left mt-4 mt-lg-0 mb-lg-5" v-bind:class="completed.includes(question.id) ? 'answered' : ''">
                        <h5 class="font-italic font-weight-light">{{ question.question }}</h5>
                        <div class="row mt-3">
                            <div class="col-12" v-if="question.type === 'free'">
                                <textarea placeholder="Type your answer here..." class="form-control btn w-100 mt-3" v-model="currenFreeTextAnswer"></textarea>
                                <button class="btn btn-primary w-100 mt-3" @click="saveResponse({'questionnaire_id' : questionnaire.id, 'question_id' : question.id, 'answered' : currenFreeTextAnswer})">Submit</button>
                            </div>
                            <div v-else class="w-100 row p-0 m-0 mt-2">
                                <div class="col-6 mt-3" v-for="options in question.options" :class="(maxOptionLength > 30 ? 'col-12' : '')">
                                    <button class="options btn w-100 btn-light"
                                            :rel="'a_' + options.id"
                                            :id="'a_' + options.id"
                                            @click="saveResponse({'questionnaire_id' : questionnaire.id, 'question_id' : question.id, 'answered' : options})">
                                        <span v-if="options.option != null">{{ options.option }}</span>
                                        <img class="option_icon" v-else :src="require('@/assets/icons/'+options.questionnaire_icon)" :alt="options.alt_text"/>
                                    </button>
                                </div>
<!--                                <div class="w-100 mt-3 px-3 d-lg-none">-->
<!--                                    <hr>-->
<!--                                </div>-->
<!--                                <button class="btn btn-primary w-100 m-3 mt-2 d-lg-none" @click="postResponse()">Save Answer</button>-->

                            </div>

                        </div>
                    </section>
                </div>
                <div v-else key="Finished" class="col-12 p-0 mt-5 " style="transition-delay: 0.4s">
                    <div class="alert alert-success mb-0">
                        You have completed this survey <i class="far fa-thumbs-up"></i>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>

</template>

<script>
import axios from "axios";

export default {
    name: 'Questionnaire',
    components: {
    },
    props: [
        'user',
        'limit'
    ],
    data() {
        return {
            questionnaire: {
                is_anonymous: {
                    type: Boolean,
                    default: false
                }
            },
            completed: [],
            currenFreeTextAnswer: '',
            results: {},
            finished: false
        }
    },
    methods: {
        saveResponse(answer) {
            $('#q_' + answer.question_id + ' .options.btn-primary').removeClass('btn-primary');

            if (answer && !this.completed.includes(answer.question_id)) {
                this.results[answer.question_id] = {
                    question_id: answer.question_id,
                    option_id: answer.answered.id ? answer.answered.id : null,
                    answer: !answer.answered.id ? answer.answered : null
                };
            }

            $('#a_' + answer.answered.id).addClass('btn-primary');
        },
        postResponse() {
            let self = this;

            if (self.results) {
                let formData = new FormData();
                formData.append('user_id', self.user.id);
                formData.append('anonymous', self.user.anonymous);
                formData.append('results', JSON.stringify(self.results));

                if (Object.entries(self.results).length === self.questionnaire.questions.length) {
                    formData.append('completed', 1);
                }
                axios.post("api/questionnaire/" + self.questionnaire.id + "/saveresponse", formData).then(response => {
                    if (response.data) {
                        if (response.data.questionnaire.length === 0) {
                            self.finished = false; //this triggers an animation
                            setTimeout(function () {
                                self.setPage('Home');
                                self.$parent.updateComponent('Home');
                            }, 1000)
                        } else {
                            if (response.data && response.data.length !== '') {
                                self.results = {};
                                self.questionnaire = response.data.questionnaire;
                                self.questionnaire.questions = JSON.parse(self.questionnaire.questions);
                            }
                        }
                    }
                });
            }
        }
    },
    mounted() {
        this.questionnaire = this.$questionnaire;
        $('.router ').prepend($('.save-answer-btn'));
        setTimeout(function () {
            $('#q-header').removeClass('hide');
        }, 200)

    },
    created() {
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Questionnaire.vue